import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'
import { useTextFit } from './useTextFit'

import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/pricehomebathroom.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'
import { ReactComponent as BlackFsc } from '../../../../../assets/zarahome/blackfsc.svg'
import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/altlogoharman.svg'
import { BASE_URL2 } from 'config/axios'
import { ReactComponent as NearQR } from '../../../../../assets/zarahome/zaranear2.svg'

import { ReactComponent as MySVG19 } from '../../../../../assets/talla.svg'
import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG21 } from '../../../../../assets/usamexuk.svg'
import { ReactComponent as MySVG22 } from '../../../../../assets/lineline.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'
import { ReactComponent as MySVGTry } from '../../../../../assets/55110.svg'
import { useAuth } from 'store/client/authStore'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma

import { ReactComponent as ZaraFscrr } from '../../../../../assets/zarahome/newfscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/zarahome/newfsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/zarahome/newfsctmpaper.svg'
import { ReactComponent as ZaraGeneralBack } from '../../../../../assets/zarahome/generalback.svg'
import { ReactComponent as ALARMHOME } from '../../../../../assets/zarahome/ALARMHOME.svg'
import { ReactComponent as Path689 } from '../../../../../assets/zarahome/path689.svg'
import { ReactComponent as Ceramic } from '../../../../../assets/zarahome/ceramic.svg'
import { ReactComponent as Zar4lu } from '../../../../../assets/zarahome/4luzara.svg'
import {ReactComponent as Housedecouttenopillow} from '../../../../../assets/zarahome/housedecouttenopillow.svg'
import {ReactComponent as Housedecouttenopillowkids} from '../../../../../assets/zarahome/housedecouttenopillowkids.svg'

import { ReactComponent as ZaraLogoNewFullfill } from '../../../../../assets/zarahome/fscfullfilnew.svg'

import {ReactComponent as AflatSheet2Pillow} from '../../../../../assets/zarahome/aflatsheet2pillow.svg'
import {ReactComponent as AflatSheetOnePillow} from '../../../../../assets/zarahome/aflatsheetonepillow.svg'
import {ReactComponent as AduvetCoverOnePillow} from '../../../../../assets/zarahome/aduvetcoveronepillow.svg'
import {ReactComponent as AduvetCoverTwoPillow} from '../../../../../assets/zarahome/aduvetcovertwopillow.svg'
import {ReactComponent as APillowCaseOnePillow} from '../../../../../assets/zarahome/apillowcaseonepillow.svg'
import {ReactComponent as APillowCaseTwoPillow} from '../../../../../assets/zarahome/apillowcasetwopillow.svg'
import {ReactComponent as APillowCaseTwoPillowRectangle} from '../../../../../assets/zarahome/apillowcasetwopillowrectangle.svg'
import {ReactComponent as AFittedBottomSheetNoPillow} from '../../../../../assets/zarahome/afittedbottomsheetnopillow.svg'
import {ReactComponent as KidsDuvetCoverOnePillow} from '../../../../../assets/zarahome/kduvetcoveronepillow.svg'
import {ReactComponent as KidsFlatSheetOnePillow} from '../../../../../assets/zarahome/kflatsheetonepillow.svg'
import {ReactComponent as KidsBottomSheetNoPillow} from '../../../../../assets/zarahome/kidsfittedbottomsheetnopillow.svg'
import {ReactComponent as KidsPillowCaseOnePillow} from '../../../../../assets/zarahome/kidspillowcaseonepillow.svg'
import {ReactComponent as KidsPillowCaseLongPillow} from '../../../../../assets/zarahome/kidspillowcaselongpillow.svg'
import {ReactComponent as KidsPillowCaseRectangle} from '../../../../../assets/zarahome/kidspillowcaserectangle.svg'


import AutoFitGroup from './autofitgroup'


import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextLeftt from './DynamicShrinkLefft'
import QRCodeComponentSpeacial from './qrcodecomponentspecial'
import RenderIndoItems from './RenderIndoItems'
import RenderIndoItemsCM from './RenderIndoItemsCM'
import DynamicTextKids from './DynamicTextKids'
import RenderIndoItemsKids from './RenderIndoItemsKıds'


export default function Pagebigfour({
  sizeData,
  renderShape,
  Path1,
  selectColor = 0,
  barcodeValue,
  qrcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  cardType,
  homeProducts,
  processedDescriptions,
  x,
  y,

}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  const [isLeather, setisLeather] = useState(false)  
const [texttt, setTexttt] = useState("")
const sizeContainerRef = useRef(null)
const [sizeFontSize, setSizeFontSize] = useState(10) // Başlangıç font boyutu 10pt
const RLI = "\u2067"; // Right-to-Left Isolate
const PDI = "\u2069"; // Pop Directional Isolate

const symbol = data.priceLabel?.[selectColor]?.symbol ?? {}

// renderShape log
console.log('Pagebigfour - renderShape prop:', renderShape);
console.log('Pagebigfour - renderShape type:', typeof renderShape);
console.log('Pagebigfour - renderShape === null:', renderShape === null);
console.log('Pagebigfour - renderShape === undefined:', renderShape === undefined);
if (renderShape && typeof renderShape === 'object') {
  console.log('Pagebigfour - renderShape keys:', Object.keys(renderShape));
  console.log('Pagebigfour - renderShape type:', renderShape.type);
  console.log('Pagebigfour - renderShape props:', renderShape.props);
}

// Text fit hook'u ekle
const { containerRef,   fontSize } = useTextFit();


const processedData = processedDescriptions[sizeData?.description] || {
  fullText: "",
  partzero: "",
  parttwo: "",
  partthree: "",
  parttwoandthree: "",
  partzerokids: "",
  parttwoandthreekids: ""
};

  // Bölmek için "/" karakterini kullan
  const selectedFscType = data.company?.fsctype;

  const leatherTypes = [
    "BUFFALO FURSKIN", "BUFFALO LEATHER", "CALF FURSKIN", "COLT LEATHER",
    "COW FURSKIN", "GOAT LEATHER", "HORSE LEATHER", "LAMB FURSKIN",
    "LAMBSKIN", "PIG FURSKIN", "PIG LEATHER", "RABBIT LEATHER",
    "SHEEP FURSKIN", "SHEEP LEATHER"
  ]

  const [brand, category, subCategory] = department ? department.split(' / ') : ['', '', '']
 
  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])




  const FSC_COMPONENTS = {
    fscrr: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctm: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctmpaper: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
  };

  const SelectedComponent = FSC_COMPONENTS[selectedFscType];

  useEffect(() => {
    if (category) {
      setCurrentShape(category)
    }
  }, [category])

  // Size container için dinamik font ayarlama - height kontrolü ile
  useEffect(() => {
    // Her yeni veri geldiğinde önce font'u 10pt'e resetle
    setSizeFontSize(10)
    
    const adjustSizeFont = () => {
      if (sizeContainerRef.current) {
        const container = sizeContainerRef.current
        const offsetHeight = container.offsetHeight // Container'ın görünen height'i (29px)
        const scrollHeight = container.scrollHeight // İçeriğin gerçek height'i
        
        // Eğer içerik aşağı düşüyorsa (scrollHeight > offsetHeight) font boyutunu küçült
        if (scrollHeight > offsetHeight) {
          const scaleFactor = offsetHeight / scrollHeight
          const newFontSize = Math.max(7, 10 * scaleFactor * 0.98) // Minimum 7pt, %98 güvenlik payı
          setSizeFontSize(Math.round(newFontSize * 10) / 10)
        }
        // Sığıyorsa zaten 10pt'de kalacak (yukarıda resetledik)
      }
    }

    // İlk render sonrası ve sizeData değiştiğinde kontrol et
    const timeoutId = setTimeout(adjustSizeFont, 150)
    
    // ResizeObserver ile container boyutu değişikliklerini izle
    let resizeObserver
    if (sizeContainerRef.current) {
      resizeObserver = new ResizeObserver(() => {
        setTimeout(adjustSizeFont, 50)
      })
      resizeObserver.observe(sizeContainerRef.current)
    }
    
    window.addEventListener('resize', adjustSizeFont)
    
    return () => {
      window.removeEventListener('resize', adjustSizeFont)
      clearTimeout(timeoutId)
      if (resizeObserver) {
        resizeObserver.disconnect()
      }
    }
  }, [sizeData])

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };
  // Optimized function using pre-cached descriptions
  function getProductTextById(id) {
    return processedDescriptions[id]?.fullText || "";
  }
  function fixMixedDirectionLabel(text) {
    if (!text) return text;
  
    // Segmentlere böl (senin formatın: " / " ile ayrılıyor)
    const parts = text.split(" / ").map(s => s.trim());
  
    // Arapça içeren segmenti izole et (Arapça Unicode blokları)
    const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  
    const fixed = parts.map(p => {
      if (arabicRegex.test(p)) {
        return `${RLI}${p}${PDI}`;
      }
      return p;
    });
  
    return fixed.join(" / ");
  }
  useEffect(() => {

    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak




  const renderSVG = (integer3, decimal3, integer4, decimal4) => {
    console.log("Values received:", { integer3, decimal3, integer4, decimal4 });
    console.log("SUBCATEGORYY",subCategory);
    // Değerleri stringe çevirip kontrol ediyoruz
    const isInteger3Valid = String(integer3).trim() !== '';
    const isDecimal3Valid = String(decimal3).trim() !== '';
    const isInteger4Valid = String(integer4).trim() !== '';
    const isDecimal4Valid = String(decimal4).trim() !== '';
  if(SouthAmerica)
  {
    return <MySVG2900 width="23.256mm" height="14.496mm" />;
    

  }
  else{
    switch (true) {
      case isInteger3Valid && isDecimal3Valid && isInteger4Valid && isDecimal4Valid:
        console.log("Case 1: All values are present (integer3, decimal3, integer4, decimal4)");
        return <MySVG20 width="21.256mm" height="14.496mm" />;
      case isInteger3Valid && isDecimal3Valid && !isInteger4Valid :
        console.log("Case 2: Only integer3 and decimal3 are present, integer4 and decimal4 are missing");
        return <MySVG249 width="21.256mm" height="14.496mm" />;
      case isInteger4Valid && isDecimal4Valid && !isInteger3Valid:
        console.log("Case 3: Only integer4 and decimal4 are present, integer3 and decimal3 are missing");
        return <MySVG250 width="21.256mm" height="14.496mm" />;
      default:
        console.log("Default Case: None of the conditions are met", { integer3, decimal3, integer4, decimal4 });
        return null; // Hiçbir koşul sağlanmazsa hiçbir şey döndürme
    }
  }
  

  };
 /* 
  <div style={{position:"absolute",left:12,top:-2}}>
  <MySVGTry style={{width:"55.2mm",height:"110.2mm"}}/>

  </div>
  */


  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])

  

  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  let shape
  
  const isBlackLabel = referance?.backgroundColor === 'B'

  const renderCardTypeContent = () => {
    switch (cardType) {
      case "General Textile":
        return (

          <div>
             
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 36,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                    <BlackFsc  width="5.604mm" height="5mm"  />
                )}
              </div>
    
          <div>

     
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
     
              <div
  className="
    absolute text-[4pt] leading-[4.1pt] text-justify pdf-force
   
  "
  style={{
    top: 160,
    left: 34.8,
    width: '174px',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext',
  }}
>{fixMixedDirectionLabel(getProductTextById(sizeData.description))}</div>
        
            
              <div></div>
           
    

     
         
    
              <div style={{position:"absolute",top:121.8,height:29,left:39.4,width:"164px",display:"flex",justifyContent:"center",alignItems:"center"}}>                  <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                     marginLeft:3.8
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
      
             
   <div
  style={{
    position: "absolute",
    top: 8.5, // px
    left: category === "Kids" ? 42 : 34.8, // px
  }}
>
  {SelectedComponent && (
    <SelectedComponent.component
      width={SelectedComponent.width}
      height={SelectedComponent.height}
    />
  )}
</div>

         
<NearQR width="2.517mm" height="7.29mm" style={{position:"absolute",top:177,left:106,opacity:1,transform: "scaleX(-1) scaleY(-1)"}}/>

              <div
  style={{
    position: 'absolute',
    top: -15,
    right: rifd ? -21 : -14
  }}
>
  <QRCodeComponentSpeacial
    barcodeValue={qrcodeValue}
    onSvgGenerated={handleSvgGenerated}
  />
  {modifiedSvgText && (
    <div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
  )}
</div>

      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
      case "Special measures":
        return (
          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 36,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <BlackFsc  width="5.604mm" height="5mm"  />
                )}
              </div>
              <div
  className="
    absolute text-[4pt] leading-[4.1pt] text-justify pdf-force
   
  "
  style={{
    top: 160,
    left: 34.8,
    width: '174px',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext',
  }}
>{getProductTextById(sizeData.description)}</div>
          <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    <div style={{ position: 'absolute', top: 118.6, left: -67,width:165}}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}xx
            >

<RenderIndoItemsCM indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />


            </div>
          </div>
   
              </div>
           
              <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
              
              <div></div>
           
    

     
         
    
             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

         
    <NearQR width="2.517mm" height="7.29mm" style={{position:"absolute",top:177,left:106,opacity:1,transform: "scaleX(-1) scaleY(-1)"}}/>

              <div style={{ position: 'absolute', top: -15, right: -21 }}>
                <QRCodeComponentSpeacial  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
      case "Adult apparel":
        return (

          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
            <DynamicShrinkText
            filteredIndo={filteredIndo}
            inx={inx}
            szrgrp={szrgrp}
            valueBasedOnInx={valueBasedOnInx}
            referance={referance}
            brand={brand}
            category={category}
            subCategory={subCategory}
          />


           <div style={{ position: 'absolute', top: 164, left: 28,width:"85%" }}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
            >

<RenderIndoItems indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />


            </div>
          </div>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 36,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <BlackFsc width="5.604mm" height="5mm"  />
                )}
              </div>
    
              <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
    
              <div></div>
           
    

     
       
    
                  <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                  <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:5.4
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
      
             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

         
     
              <div style={{ position: 'absolute', top: -15, right: -21 }}>
                <QRCodeComponentSpeacial  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
        
        
        
        case "Kids apparel":
        return (

          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>

            <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>

         
            <DynamicTextKids
            filteredIndo={filteredIndo}
            inx={inx}
            szrgrp={szrgrp}
            valueBasedOnInx={valueBasedOnInx}
            referance={referance}
            brand={brand}
            category={category}
            subCategory={subCategory}
          />
   </div>

           <div style={{ position: 'absolute', top: 164, left: 28,width:"85%" }}>
            <div
              style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
            >

      <RenderIndoItemsKids indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />


            </div>
          </div>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 36,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <BlackFsc  width="5.604mm" height="5mm"  />
                )}
              </div>
    
              <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
    
              <div></div>
           
    

     
       
    

             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

         
     
              <div style={{ position: 'absolute', top: -15, right: -21 }}>
                <QRCodeComponentSpeacial  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
      case "Object":
        return (
          <div>
          <div>
            <div>
            <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
              <div
                style={{
                  position: 'absolute',
                  top: 9,
                  right: 36,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                {rifd && (
                  <BlackFsc  width="5.604mm" height="5mm"  />
                )}
              </div>
    
    <div className="text-[4pt] leading-[4.1pt] text-justify pdf-force" style={{ position: 'absolute', top:157.4, left: 34.6, // 86mm biraz dar olabilir, 1–2 mm tolerans ver
 
    fontWeight: '400',
    fontsize:4,
    width:"175px",
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext', }}>
    
    <div style={{display: 'block', marginBottom: '5px'}}>{getProductTextById(sizeData.description)}</div>
    <div style={{display: 'block',marginBottom: '5px'}}>AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 (ZARAHOME.COM/CONTACT) ITX USA LLC. ZARA HOME BRASIL P. L. LTDA . CNPJ:13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 （株）ITXジャ パン (81 120 272 202) BRASILITX P. L. LCanada TDA. Ltd. CNPJ:13.144.185/0001-50 아이티엑스코리아MODA주식회사HOME , S.A.S. 서울특별시SIC 900.495.729강남구 ITX영동대로 511 (삼성동) 20층 2002호 080-500-6445. RUC 80089402-2. MA-MAROC : Sté RTW MAROC IF : 1642262. : IMPORTADO POR ZARAHOME MEXICO, S.A. DE C.V.PONIENTE 146 NO. 730 COLONIAINDUSTRIALVALLEJO ALCALDIAAZCAPOTZALCO, C.P. 02300, CIUDAD DE MEXICO, RFC:ZHM040609ES5.</div>
    <div style={{ display: 'block' }}>
  {data.country.translate
    .map((item) => item.translation)
    .join(' / ')}
</div>
    
    </div>
    <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
              <div></div>
           
    

     
         
    
                  <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                  <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "13.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:5.4
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
      
             
              <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

    
         
     
              <div style={{ position: 'absolute', top: -15, right: -21 }}>
                <QRCodeComponentSpeacial  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
        case "Basket":
          return (
            <div>
            <div>
              <div>
              <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
              <div
                  style={{
                    position: 'absolute',
                    top: 9,
                    right: 36,
      
                    justifyContent: 'center',
                    display: 'grid',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  {rifd && (
                    <BlackFsc  width="5.604mm" height="5mm"  />
                  )}
                </div>
      
                <div className="text-[3.7pt] leading-[4.1pt] text-justify pdf-force" style={{ position: 'absolute', top:157.4, left: 34.6, // 86mm biraz dar olabilir, 1–2 mm tolerans ver
    fontWeight: '400',
    fontsize:4,
    width:"175px",
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    unicodeBidi: 'plaintext', }}>
    
    <div style={{display: 'block', marginBottom: '5px'}}>{getProductTextById(sizeData.description)}</div>
    <div style={{display: 'block',marginBottom: '5px'}}>ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL, QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.</div>
    <div style={{ display: 'block' }}>
  {data.country.translate
    .map((item) => item.translation)
    .join(' / ')}
</div>
    
    </div>
    <div
                style={{
                  position: 'absolute',
                  top: 7.5,
                  left: 107.2,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
          
      <div style={{ position: 'absolute', top: 120.6, left: -67,width:165}}>
              <div
                style={{ display: 'flex', justifyContent: 'center', textAlign: 'center',width:"100%" }}
              >
  
  <RenderIndoItemsCM indo={filteredIndo} startIndex={valueBasedOnInx} indexxx={indexedIndo} />
  
  
              </div>
            </div>
      

      
                </div>
          
                <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
                <div></div>
             
      
  
       
           
      
               
                <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
                {SelectedComponent && (
        <SelectedComponent.component
          width={SelectedComponent.width}
          height={SelectedComponent.height}
        />
      )}
      </div>

      
           
        <NearQR width="2.517mm" height="7.29mm" style={{position:"absolute",top:177,left:59,opacity:1,transform: "scaleX(-1) scaleY(-1)"}}/>
                <div style={{ position: 'absolute', top: -15, right: -21 }}>
                  <QRCodeComponentSpeacial  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                  {modifiedSvgText && (
                    <div
        dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
      
      ></div>
      
            )}
                </div>
        
             
         
                <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                  <Barcode
                    value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                    format="ITF14"
                    width={0.921}
                    height={25.9}
                    marginLeft={1}
                    marginRight={1}
                    marginTop={1}
                    marginBottom={1}  
                    background="transparent"
                    lineColor={isBlack ? '#ffffff' : '#000000'}
                    textMargin={0}
                    fontSize={8} // 7pt yaklaşık olarak 9px
                    font="Arial"
                  />
                </div>
      
       
                <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                      ART
                    </p>  
                    <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                      .:
                    </p>
                    <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                    {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                    </p>
                  </div>{' '}
                </div>
              </div>
            </div>
          </div>
          );
          
          
          case "Food contact":
            return (
              <div>
              <div>
                <div>
                <Path689 width="52mm" height="auto" style={{position:"absolute",top:-19,left:24,opacity:1}}/>
                <div
                    style={{
                      position: 'absolute',
                      top: 9,
                      right: 36,
        
                      justifyContent: 'center',
                      display: 'grid',
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    {rifd && (
                      <BlackFsc  width="5.604mm" height="5mm"  />
                    )}
                  </div>
        
        <div className="text-[4.7pt] leading-[4.6pt] text-justify" style={{ position: 'absolute', top:157.4, left: 34.6, // 86mm biraz dar olabilir, 1–2 mm tolerans ver
        fontFamily: 'arial-narrow',
        fontWeight: '400',
        fontsize:4,
        width:"175px",
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal', }}>
        
        <div className='text-[4.5pt]' style={{display: 'block', marginTop: '4px',marginBottom:6, letterSpacing:"-0.5px",textAlign:"center"}}>PIEL BOVINA / COW LEATHER / CUIR DE VACHETTE / 牛皮革 / 牛皮 / 소가죽</div>
        <div style={{display: 'block',marginBottom: '5px',letterSpacing:"-0.3px"}}>ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ: 13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 （株）ITXジャ パン (0120-914-075) #RN 138445 ZARA HOME CANADA INC. 1550 MONTRÉAL, QUEBEC, H3B 4G7 MA-MAROC : Sté RTW MAROC IF : 1642262.</div>
        <div style={{ display: 'block',letterSpacing:"-0.3px",marginBottom:7}}>
      {data.country.translate
        .map((item) => item.translation)
        .join(' / ')}
    </div>
    <div><Ceramic width="45.531mm" height="auto"/></div>
        
        </div>
        <div
                style={{
                  position: 'absolute',
                  top: x,
                  left: y,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        
    
    {renderShape}
    
              </div>
           
                  <div></div>
               
        
    
         
             
        
                      <div style={{position:"absolute",top:122,height:29,left:40,width:"165px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                      <p className="arial-bold"
                        style={{
                          fontSize: "13.3px",
                          lineHeight: "19.7px",
                          letterSpacing: "0px",
                          color: "black",
                        }}
                      >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                         <p className="arial-bold"
                        style={{
                          fontSize: "13.3px",
                          lineHeight: "19.7px",
                          letterSpacing: "0px",
                          color: "black",
                          marginLeft:5.4
                        }}
                      >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                      </div>
          
                 
                  <div style={{ position: 'absolute', top: 8, left: 34.6 }}>
                  {SelectedComponent && (
          <SelectedComponent.component
            width={SelectedComponent.width}
            height={SelectedComponent.height}
          />
        )}
        </div>
        
   
             
         
                  <div style={{ position: 'absolute', top: -15, right: -21 }}>
                    <QRCodeComponentSpeacial  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                    {modifiedSvgText && (
                      <div
          dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
        
        ></div>
        
              )}
                  </div>
          
               
           
                  <div ref={barcodeRef} style={{ position: 'absolute', top: 62.4, left: 59,width:"35mm",height:"10.310mm"}}>
                    <Barcode
                      value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                      format="ITF14"
                      width={0.921}
                      height={25.9}
                      marginLeft={1}
                      marginRight={1}
                      marginTop={1}
                      marginBottom={1}  
                      background="transparent"
                      lineColor={isBlack ? '#ffffff' : '#000000'}
                      textMargin={0}
                      fontSize={8} // 7pt yaklaşık olarak 9px
                      font="Arial"
                    />
                  </div>
        
         
                  <div style={{ position: 'absolute', top: 45.2, left: 65.5}}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                        ART
                      </p>  
                      <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                        .:
                      </p>
                      <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                      {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                      </p>
                    </div>{' '}
                  </div>
                </div>
              </div>
            </div>
            );
          

      default:
        // Eğer cardType yoksa veya tanınmıyorsa, mevcut renderShape'i kullan
        <></>
    }
  };

  // Kart tipi için şartlı SVG component'i
  const renderCardTypeSvg = (cardType, pillowtypeYY) => {
    switch (cardType) {
      case 'ADULT - FLAT SHEET':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AflatSheet2Pillow width="35.867mm" height="20.017mm" />
            </div>
          );
        } else if (pillowtypeYY === 'TEK YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AflatSheetOnePillow width="35.867mm" height="20.017mm" />
            </div>
          );
        }
        return null;
  
      case 'ADULT - DUVET COVER':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AduvetCoverTwoPillow width="37.591mm" height="19.922mm" />
            </div>
          );
        } else if (pillowtypeYY === 'TEK YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AduvetCoverOnePillow width="37.591mm" height="19.922mm" />
            </div>
          );
        }
        return null;
  
      case 'ADULT - FITTED BOTTOM SHEET':
    
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AFittedBottomSheetNoPillow width="35.829mm" height="17.923mm" />
            </div>
          );
  
  
      case 'ADULT - PILLOW CASE':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <APillowCaseTwoPillow width="35.867mm" height="20.017mm" />
            </div>
          );
          } else if (pillowtypeYY === 'TEK YASTIK') {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <APillowCaseOnePillow width="35.867mm" height="20.017mm" />
              </div>
            );
          }
          else if (pillowtypeYY === 'KARE YASTIK') {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <APillowCaseTwoPillowRectangle width="35.867mm" height="20.017mm" />
              </div>
            );
          }
        return null;
  
      case 'KIDS - DUVET COVER':

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsDuvetCoverOnePillow width="37.591mm" height="19.922mm" />
            </div>
          );
     
  
      case 'KIDS - FLAT SHEET':

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsFlatSheetOnePillow width="35.867mm" height="20.017mm" />
            </div>
          );

 
  
      case 'KIDS - FITTED BOTTOM SHEET':

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsBottomSheetNoPillow width="35.829mm" height="17.923mm" />
            </div>
          );

  
      case 'KIDS - PILLOW CASE':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsPillowCaseOnePillow width="35.867mm" height="20.017mm" />
            </div>
          );
        } else if (pillowtypeYY === 'TEK YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsPillowCaseLongPillow width="35.867mm" height="20.017mm" />
            </div>
          );
        }
        else if (pillowtypeYY === 'KARE YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsPillowCaseRectangle width="35.867mm" height="20.017mm"/>
            </div>
          );
        }
        return null;
  
      default:
        return null;
    }
  };
  

  return (
    <div>
             <div>
          <div>
          <div style={{position:"absolute",top:14.5,left:128}}>
          <div style={{position:"relative",width:"52mm",height:"90mm",marginTop:-1}}>
          <div
                style={{
                  position: 'absolute',
                  bottom: x-2.5,
                  right: y-24,
                  display: 'flex', // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center', // Dikeyde ortalama
        width:"30px",
        height:"30px",
                }}
              >
    
        {(() => {
          console.log('renderShape değeri:', renderShape);
          console.log('renderShape tipi:', typeof renderShape);
          console.log('renderShape === null:', renderShape === null);
          console.log('renderShape === undefined:', renderShape === undefined);
          console.log('renderShape === false:', renderShape === false);
          console.log('renderShape === <></>:', renderShape?.type?.toString());
          return renderShape;
        })()}
    
              </div>
          <div
                style={{
                  position: 'absolute',
                  bottom: 11.6,
                  right: 38,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center',
                  transform:"scaleY(-1) scaleX(-1)"
                }}
              >
                {rifd && (
                  <BlackFsc  width="5.604mm" height="5mm"  />
                )}
              </div>
<NearQR width="4.597mm" height="12.392mm" style={{position:"absolute",bottom:7,left:60,opacity:1,transform: "scaleX(-1) scaleY(-1)"}}/>

              <div style={{ position: 'absolute', bottom: -7, left: -8.4,transform:"scale(-1) " }}>
                <QRCodeComponentSpeacial  barcodeValue={qrcodeValue}  onSvgGenerated={handleSvgGenerated} />
                {modifiedSvgText && (
                  <div
      dangerouslySetInnerHTML={{ __html: modifiedSvgText }}
    
    ></div>
    
          )}
              </div>
      
              <div
  style={{
    position: "absolute",
    bottom:  category === "Kids" ? 11 : 11.5, // px             // px
    right: category === "Kids" ? 45 : 9.9, // px
    transform: "scaleY(-1) scaleX(-1)",
    transformOrigin: "center",  // opsiyonel: flip sonrası hizayı korumaya yardımcı olur
  }}
>
  {SelectedComponent && (
    <SelectedComponent.component
      width={SelectedComponent.width}
      height={SelectedComponent.height}
    />
  )}
</div>

    <div ref={barcodeRef} style={{ position: 'absolute', bottom: 79.4, right: 34.5,width:"35mm",height:"10.310mm",transform:"scaleY(-1) scaleX(-1)"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>

              <div style={{ position: 'absolute', bottom: 62, right: 41.4,transform:"scaleY(-1) scaleX(-1)"}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '0' }}>
                    ART
                  </p>  
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginRight: '8px' }}>
                    .:
                  </p>
                  <p className="helve-roman" style={{ fontSize: '8.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>

              <div 
                ref={sizeContainerRef}
                style={{position:"absolute",top:172,height:29,left:16,width:"165px",display:"flex",justifyContent:"center",alignItems:"center",transform:"scaleY(-1) scaleX(-1)",padding:"0 2px"}}
              >
                  <p className="arial-bold"
                    style={{
                      fontSize: `${sizeFontSize}pt`,
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: `${sizeFontSize}pt`,
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:5.4
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                  </div>
                  <div className="text-[3.7pt] leading-[3.2pt] text-justify pdf-force">

                  <div
  className='pdf-force'
  style={{
    position: "absolute",
    top: 139,
    height: 29,
    left: 12,
    width: "173px",
    transform: "scaleY(-1) scaleX(-1)",
    fontWeight: "400",
    whiteSpace: "normal",
    wordBreak: "normal",
    overflowWrap: "normal",
    unicodeBidi: "plaintext",
    padding: "0 5px" // sağdan ve soldan 5px boşluk
  }}
>
  {data.country.translate.map((item) => item.translation).join(" / ")}
</div>

              
              </div>
          </div>
       
          </div>
          <div style={{position:"absolute",top:-1.5,left:332}}>
          <div className="flex items-center h-full" style={{position:"absolute", top:60, right:36,transform: "rotate(180deg) scale(1.25)",height:60 }}>
              <div className="flex items-center h-full ">
           <div className="flex items-start justify-between px-[6mm] w-full" >
           <div
  className="w-[21.3mm] h-[14mm] grid grid-cols-5 grid-rows-3 place-items-center items-start gap-x-0 gap-y-[-1px]"
 
>
  {/* Üst sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}.svg`}
    alt="sembol icon"
    style={{ width: 13, height: 14, padding: 0.4 ,marginLeft:1.4,marginTop:-0.6}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}.svg`}
    alt="sembol icon"
    style={{ width: 14, height: 15, padding: 0.4,marginTop:-1,marginLeft:-1.2,opacity:1 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}.svg`}
    alt="sembol icon"
    style={{ width: 10.5, height: 10.5, padding: 0.4,marginLeft:-1,marginTop:1.8 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}.svg`}
    alt="sembol icon"
    style={{ width: 13.5, height: 12, padding: 0.4,marginTop:1.1,marginLeft:-2 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}.svg`}
    alt="sembol icon"
    style={{ width: 11.5, height: 11.5, padding: 0.4 ,marginLeft:-1.6,marginTop:1.3}}
  />

  {/* Orta sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_1.svg`}
    alt="sembol icon"
    style={{  width: 13, height: 12.6, padding: 0.4 ,marginLeft:1,marginTop:-1.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_1.svg`}
    alt="sembol icon"
    style={{ width: 14.7, height: 14.7, padding: 0.4 ,marginLeft:-2,marginTop:-2 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_1.svg`}
    alt="sembol icon"
    style={{  width: 15.9, height: 14.8, padding: 0.4 ,marginLeft:1.4,marginTop:-2.3}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_1.svg`}
    alt="sembol icon"
    style={{  width: 13, height: 13, padding: 0.4 ,marginLeft:1.2,marginTop:-1.1 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_1.svg`}
    alt="sembol icon"
    style={{ width: 10.5, height: 11.5, padding: 0.4 ,marginLeft:-1.2,marginTop:-0.4 }}
  />

  {/* Alt sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_2.svg`}
    alt="sembol icon"
    style={{ width: 15, height: 14.8, padding: 0.4 ,marginLeft:1,marginTop:-2.9 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_2.svg`}
    alt="sembol icon"
    style={{ width: 14.5, height: 14.5, padding: 0.4 ,marginLeft:-1,marginTop:-3.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_2.svg`}
    alt="sembol icon"
    style={{ width: 11.5, height: 11.5, padding: 0.4 ,marginLeft:-0.5,marginTop:-2.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_2.svg`}
    alt="sembol icon"
    style={{ width: 14.9, height: 11.5, padding: 0.4 ,marginLeft:-1.7,marginTop:-2.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_2.svg`}
    alt="sembol icon"
    style={{ width: 11.5, height: 11.5, padding: 0.4 ,marginLeft:-1.4,marginTop:-3.3 }}
  />
</div>

        
          </div>
        </div>
          </div>
          <div style={{position:"relative",width:"52mm",height:"90mm",marginTop:-1}}>
          <div
                style={{
                  position: 'absolute',
                  bottom: 39.3,
                  left: 10.3,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center',
                  transform:"scaleY(-1) scaleX(-1)"
                }}
              >


<div 
  ref={containerRef}
  className="text-justify pdf-force" 
  style={{
    transform: "scaleY(-1) scaleX(-1)",
    fontSize: fontSize,
    lineHeight: "1.2",
    width: "176px", // Sabit genişlik
    maxHeight: "40mm", // 40mm maksimum yükseklik
    overflow: "hidden"
  }}
>
  {/* Kumaş bilgileri */}
  <div style={{ marginBottom: 2, marginLeft: 2 }}>
    {data.priceLabel[selectColor].fabric?.map((fabric, i) =>
      fabric.mix?.map((mix, j) => (
        mix.text && (
          <p
            key={`${i}-${j}`}
            className="pdf-force"
            data-text-fit
            style={{
              width: "100%",
              transform: "scaleY(-1) scaleX(-1)",
              fontWeight: "400",
              whiteSpace: "normal",
              wordBreak: "normal",
              overflowWrap: "normal",
              unicodeBidi: "plaintext",
              fontSize: fontSize,
            }}
          >
            {mix.percent && (
              <span>
                {String(mix.percent).toUpperCase()}%
              </span>
            )}{" "}
            {mix.text.toLowerCase()}
          </p>
        )
      ))
    )}
  </div>

  {/* Şirket bilgileri */}
  <div
    className='pdf-force'
    data-text-fit
    style={{
      width: "100%",
      transform: "scaleY(-1) scaleX(-1)",
      fontWeight: "400",
      whiteSpace: "normal",
      wordBreak: "normal",
      overflowWrap: "normal",
      marginBottom: 2,
      unicodeBidi: "plaintext",
      fontSize: fontSize,
    }}
  >
    ZARA HOME ESPAÑA, S.A. AV. DIPUTACIÓN. ED. INDITEX. ARTEIXO. A CORUÑA C.I.F. A-15340516 FASHION LOGISTICS LLC ZARA HOME BRASIL P. L. LTDA. CNPJ:13.144.185/0001-50 MODA HOME S.A.S. SIC 900.495.729 (株) ITXジャパン (0120-914-075). #RN 138445 ZARA HOME CANADA INC. CA 57942 MONTRÉAL, QUEBEC, H3B 4G7. 아이티엑스코리아 서울시 강남구 영동대로 511 트레이드센터 33층 080-500-6445. RUC 80089402-2. MA-MAROC : Sté RTW MAROC IF : 1642262. IMPORTADO POR ZARA HOME MEXICO, S.A. DE C.V. PONIENTE 146 NO. 730 COLONIA INDUSTRIAL VALLEJO ALCALDIA AZCAPOTZALCO, C.P. 02300, CIUDAD DE MEXICO, RFC:ZHM040609ES5
  </div>

  {/* Ürün açıklaması */}
  <div
    className='pdf-force'
    data-text-fit
    style={{
      width: "100%",
      transform: "scaleY(-1) scaleX(-1)",
      fontWeight: "400",
      whiteSpace: "normal",
      wordBreak: "normal",
      overflowWrap: "normal",
      unicodeBidi: "plaintext",
      fontSize: fontSize,
    }}
  >
    {getProductTextById(sizeData.description)}
  </div>
</div>



              
              </div>

            
             
          </div>
          </div>

          <div style={{position:"absolute",top:355,left:128}}>
   
          <div style={{position:"relative",width:"52mm",height:"90mm",marginTop:-1}}>
          {category === 'Kids'|| subCategory === 'KIDS' ? <Housedecouttenopillowkids  width="52mm" height="auto" style={{position:"absolute",top:0,left:0}}></Housedecouttenopillowkids> : <Housedecouttenopillow  width="52mm" height="auto" style={{position:"absolute",top:0,left:0}}></Housedecouttenopillow>}
          
          {/* Kart tipi SVG component'i */}
          {sizeData?.cardtypeXX && (
            <div style={{
              position: "absolute",
              top: 188,
              left: 32,
              zIndex: 10
            }}>
              {renderCardTypeSvg(sizeData.cardtypeXX,sizeData.pillowtypeYY)}
            </div>
          
          )}
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",position:"absolute",top:0,left:0,width:"52mm"}}>
          <AutoFitGroup processedData={processedData} widthMm={52} />
                  </div>
          <div
  style={{
    position: "absolute",
    top: 121,
    width: 197,
    display: "flex",
    flexDirection: "column", // ✅ düzeltildi
    justifyContent: "center",
    alignItems: "center",

  }}
>
  <span     className="zara-regular"
      style={{ fontSize: "8pt" }}>{sizeData?.carddesc}</span>

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <span
      className="zara-regular"
      style={{ fontSize: "8pt" }}
    >
      {sizeData.cm
        ?.replace(/\s*x\s*/g, "x") // boşluklu x'i düzelt
        .replace(/cm$/i, "CM") // cm'yi özel ele al
        .toUpperCase() // geri kalanını uppercase yap
     }{" "}
      {/* en sondaki CM'yi tekrar küçük yap */}
    </span>
    <span
      className="zara-regular"
      style={{ fontSize: "8pt", marginLeft: "3.7px" }}
    >
    /
    </span>
    <span
      className="zara-regular"
      style={{ fontSize: "8pt", marginLeft: "3.7px" }}
    >
      {sizeData.inches?.replace(/\s*x\s*/g, "x").toUpperCase()}
    </span>
  </div>

               </div>
          </div>
          </div>

          </div>
        </div>

    </div>
  )
}
